import { usePrincipal } from '../application/authentication'
import { useProduct } from '../application/product/ProductProvider'
import { useProposal } from '../application/product/proposal/ProposalProvider'
import { withApiErrorHandling } from '../clients/api'
import { CustomerCheckResults, getCurrentQuote, isCheckoutSkippable } from '../domain'
import { getFeatureToggles, isCheckEnabled, useConfig } from '../state/configuration'
import { useErrorHandlingAsyncCallback } from './errors'
import { useQuotePremiums } from './premiums'

export const useCheckoutProposal = (
  onSuccess: () => void,
  onUnverified: (checks: CustomerCheckResults) => void,
  onOutstandingBalance: () => void,
) => {
  const { apiClient } = usePrincipal()
  const { product } = useProduct()
  const { dispatch, proposal } = useProposal()

  const { acceptProposalTerms } = useConfig(getFeatureToggles)

  const quote = getCurrentQuote(proposal)
  const premiums = useQuotePremiums(quote, product)

  return useErrorHandlingAsyncCallback(async () => {
    const customerVerified = isCheckEnabled(product, 'verify')
      ? await apiClient.verifyCustomer(proposal.proposalCode)
      : { isClear: true, checks: {} }

    customerVerified.isClear
      ? await withApiErrorHandling(
          async () => {
            const customerAccount = await apiClient.createCustomerAccount(
              proposal.proposalCode,
            )

            if (acceptProposalTerms) {
              await apiClient.acceptProposalTerms(proposal.proposalCode)
            }

            if (isCheckoutSkippable(customerAccount, premiums)) {
              dispatch({
                type: 'UPDATE_PROPOSAL',
                payload: await apiClient.bindProposal(proposal.proposalCode),
              })
            }

            onSuccess()
          },
          onOutstandingBalance,
          [402],
        )
      : onUnverified(customerVerified.checks)
  })
}
